import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { LibTableComponent } from '@tuain/ng-forms';
import { tuainFormsBaseModules, tuainBaseComponents } from '@components/tuain.modules';
import { AppLoggerService } from '@services/app-logger.service';

@Component({
  standalone: true,
  selector: 'app-credit-amortization-table',
  imports: [...tuainFormsBaseModules, ...tuainBaseComponents],
  templateUrl: './simulation-result-table.component.html',
  styleUrls: ['./simulation-result-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimulationResultTableComponent extends LibTableComponent {
  readonly Array = Array;
  colSpan: any = { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 };
  private logger = inject(AppLoggerService);

  override start() {
    super.start();
    this.logger.debug('Usando un renderer custom');
    const { xs = 24, sm = 12, md = 8, lg = 6, xl = 4, xxl = 4 } = this.customAttributes()?.['cardSpan'] ?? {};
    this.colSpan = { xs, sm, md, lg, xl, xxl };
  }
}
